import { createAPIModule } from 'utility/redux/apiModuleHelpers';

const getStateSlice = (state) => state.api.storm.template.restore;

const {
	actions,
	reducer,
	sagas,
	selectors: defaultSelectors,
	additionalSagas,
} = createAPIModule({
	getStateSlice,
	actionType: 'STORM_TEMPLATE_RESTORE',
	method: 'POST',
	url: '/storm/template/restore.json',
});

const selectors = {
	...defaultSelectors,
};

export {
	actions,
	reducer,
	sagas,
	selectors,
	additionalSagas as templateRestoreAdditionalSagas,
};
